module.exports = __webpack_public_path__ + "303e86670bc9961e07778ea57875fe9a.png";